<template>
  <button @click="open">
    <slot />
  </button>
</template>

<script>
import { useStore } from 'vuex';
import { toRefs } from 'vue';
import { usePaginator } from '@composables/use-paginator';

export default {
  props: {
    targetId: {
      type: String,
    },
    targetGalleryId: {
      type: String,
      default: undefined,
    },
    targetGalleryItemId: {
      type: String,
      default: undefined,
    },
  },
  setup(props) {
    const store = useStore();
    const { targetId, targetGalleryId, targetGalleryItemId } = toRefs(props);

    const open = () => {
      if (targetGalleryItemId.value) {
        const { setCurrentItem } = usePaginator({
          id: targetGalleryId.value,
        });

        setCurrentItem(targetGalleryItemId.value);
      }

      store.dispatch('lightbox/open', {
        instanceKey: targetId.value,
      });
    };

    return { open };
  },
};
</script>
